import { render, staticRenderFns } from "./tenant-detail.vue?vue&type=template&id=71664f36&scoped=true"
import script from "./tenant-detail.vue?vue&type=script&lang=js"
export * from "./tenant-detail.vue?vue&type=script&lang=js"
import style0 from "./tenant-detail.vue?vue&type=style&index=0&id=71664f36&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71664f36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71664f36')) {
      api.createRecord('71664f36', component.options)
    } else {
      api.reload('71664f36', component.options)
    }
    module.hot.accept("./tenant-detail.vue?vue&type=template&id=71664f36&scoped=true", function () {
      api.rerender('71664f36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/tenants/detail/tenant-detail.vue"
export default component.exports